import clsx from "clsx";
import style from "components/EventLocation.module.scss";
import { Location } from "components/Icons";
import React from "react";

const EventLocation = ({ event }) => {
  const className = clsx(style.root, style[`root___iconTheme_${iconTheme}`]);

  return (
    <div className={className}>
      <div className={style.icon}>
        <Location />
      </div>
      <div className={style.label}>
        {event.isRemote ? "Remote" : event.venueAddress}
      </div>
    </div>
  );
};

export default EventLocation;
